import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaFileInvoiceDollar } from 'react-icons/fa6';
import Invoices from "./index";
import ViewInvoice from "./view";
import CreateInvoice from "./create";
import EditInvoice from "./edit";
import { MODULE_INVOICES } from "variables/constants";

const invoiceRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Invoices",
		basePath: "invoices",
		mainComponent: <Invoices />,
	    layout: "/console",	   
	    icon: <FaFileInvoiceDollar className="icon-item" />,
	    subTitle:"Invoice",
	    viewComponent: <ViewInvoice />,
	    createComponent: <CreateInvoice />,
	    editComponent: <EditInvoice />,
		level:3,
		moduleId: MODULE_INVOICES,
	})
]

export default invoiceRoutes;